<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="24.0005"
      cy="23.9998"
      r="20"
      transform="rotate(-180 24.0005 23.9998)"
      fill="#F1636F"
    />
    <rect
      x="27"
      y="36"
      width="6"
      height="6"
      transform="rotate(-180 27 36)"
      fill="white"
    />
    <rect
      x="27"
      y="26.4"
      width="6"
      height="15.6"
      transform="rotate(-180 27 26.4)"
      fill="white"
    />
  </svg>
</template>
